<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Artist Merge</h4>
      </div>
    </div>
    <div class="content-container" style="max-height: 72px;">
      <section style="padding: 1rem;">
        <div class="grid-x grid-padding-x">
          <div class="cell">
            <TheTextInput containerClassName="cell medium-6 large-6" label="Search for the artist" name="Artist" v-model.trim="artistSearch" @keyup="handleInput"/>
          </div>
        </div>
      </section>
    </div>
    <div class="content-container flex-row">
      <section class="content small scrollnav" style="padding: 1rem;">
        <TheLoader :active="isLoading" update="true"/>
        <div class="grid-x grid-padding-x">
          <div class="cell medium-6 large-6">
            <div class="merge-card-block">
              <div class="merge-card-title">
                To Merge To
                <span>Select the Artist that will be maintained</span>
              </div>

              <div v-if="artistsList.length > 0">
                <div class="merge-card" v-for="(artist, index) in artistsList" v-bind:key="index" @click="selectArtistToMerge(artist.Idnr)" v-bind:class="{ 'selected': selectedToMerge === artist.Idnr }">
                  <div class="artist-name">{{ artist.Navn }}</div>
                  <div class="artist-relation">{{ artist.total_objects }} objects</div>
                </div>
              </div>
              <div v-else>
                <div class="merge-card-no-artist">
                  <p>No artists found</p>
                </div>
              </div>
            </div>
          </div>
          <div class="cell medium-6 large-6">
            <div class="merge-card-block">
              <div class="merge-card-title">
                To Be Merged
                <span>Select the Artists that will be removed</span>
              </div>
              <div v-if="artistsList.length > 0">
                <div class="merge-card merge-card-two-columns" v-for="(artist, index) in artistsList" v-bind:key="index" @click="selectArtistsToBeMerged(artist.Idnr)" :class="{ 'selected': selectedToBeMerged.includes(artist.Idnr), 'selected-to-merge': selectedToMerge === artist.Idnr }">
                  <div class="merge-card-left">
                    <div class="artist-name">
                      {{ artist.Navn }}
                    </div>
                    <div class="artist-relation">{{ artist.total_objects }} objects</div>
                  </div>
                  <div v-show="artist.total_objects === 0" class="merge-card-right">
                    <button class="artist-delete" @click="handleDelete(artist.Idnr)">
                      <img src="/static/img/trash.svg" alt="Delete">
                    </button>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="merge-card-no-artist">
                  <p>No artists found</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-x" style="padding: 1rem;">
          <div class="cell">
            <div class="grid-x">
              <div class="cell">
                <button class="button primary large" style="width: 100%;" @click="handleSubmit">Merge selected</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div class="modal-container" :class="{'active': showMergeModal}">
      <div class="modal-window large" :class="{'active': showMergeModal}">
        <div class="modal-window-header gray">
          <div class="modal-window-heading">
            <h3>Confirm Merge</h3>
          </div>
        </div>
        <div class="modal-window-body gray scrollable">
          <div class="merge-preview">
            <div class="merge-column">
              <h4>To Be Merged</h4>
                <div v-for="id in selectedToBeMerged" :key="id">
                  {{ getArtistName(id) }}
                </div>
            </div>
            <div class="merge-arrow">→</div>
            <div class="merge-column">
              <h4>Merge Into</h4>
              <p class="to-merge-name">{{ getArtistName(selectedToMerge) }}</p>
            </div>
          </div>
        </div>
        <div class="modal-window-footer" style="text-align: end;">
          <button class="button secondary large" @click="showMergeModal = false">Cancel</button>
          <button class="button primary large" @click="confirmMerge">Confirm</button>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .merge-card-block {
    border: 1px solid #aaaaaa;
    border-radius: 5px;
  }
  .merge-card-block .merge-card-title {
    background-color: #FFFFFF;
    border-radius: 5px 5px 0 0;
    border-bottom: 1px solid #aaaaaa;
    height: 60px;
    text-align: center;
    font-weight: bold;
    padding-top: 10px;
  }
  .merge-card-block .merge-card-title span {
    display: block;
    font-size: 12px;
    color: #6c6c6c;
  }
  .merge-card-block .merge-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 96%;
    height: 65px;
    background-color: #f4f4f4;
    margin: 2%;
    cursor: pointer;
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
  }
  .merge-card-block .merge-card-two-columns {
    display: flex;
    align-items: center;
    flex-direction: row;
  }
  .merge-card-block .merge-card .merge-card-left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    width: 80%;
  }
  .merge-card-block .merge-card.selected {
    background-color: #e3e3e3;
    border: 1px solid #707070;
    box-shadow: 0 3px 7px rgba(0, 0, 0, 0.3);
  }
  .merge-card-block .merge-card.selected-to-merge {
    opacity: 0.5;
  }
  .merge-card-block .merge-card-no-artist {
    padding: 10px;
    text-align: center;
  }
  .merge-card-block .merge-card-no-artist p {
    margin: 12px;
    font-size: 15px;
  }
  .merge-card-block .artist-delete {
    background-color: #e3e3e3;
    border: 1px solid #707070;
    border-radius: 50%;
    padding: 3px;
    cursor: pointer;
  }
  .merge-card-block .artist-delete img {
    width: 22px;
    height: 22px;
  }
  .merge-card-block .artist-relation {
    font-size: 12px;
    color: #6c6c6c;
  }
  .scrollable {
    overflow-y: auto;
    max-height: 500px;
  }
  .merge-preview {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;
    padding: 1rem;
  }
  .merge-column {
    flex: 1;
    background-color: #f9f9f9;
    padding: 1rem;
  }
  .merge-column h4 {
    margin-bottom: 0.5rem;
    font-weight: bold;
    color: #333;
  }
  .merge-column ul {
    list-style-type: disc;
    padding-left: 1.2rem;
  }
  .merge-column li {
    margin-bottom: 0.25rem;
    color: #555;
  }
  .to-merge-name {
    font-size: 1.1rem;
    font-weight: 600;
    color: #2a2a2a;
    margin-top: 0.5rem;
  }
  .merge-arrow {
    font-size: 2rem;
    font-weight: bold;
    color: #444;
  }
</style>
<script>
import SearchService from '../../../services/SearchService'
import KunstnerService from '../../../services/KunstnerService'

export default {
  name: 'VerktoyKunstnerMerge',
  data () {
    return {
      isLoading: false,
      artistSearch: '',
      artistsList: [],
      selectedToMerge: '',
      selectedToBeMerged: [],
      typingTimeout: null,
      showMergeModal: false
    }
  },
  methods: {
    selectArtistToMerge (artistId) {
      this.selectedToMerge = artistId
      this.selectedToBeMerged = this.selectedToBeMerged.filter(artist => artist !== this.selectedToMerge)
    },
    selectArtistsToBeMerged (artistId) {
      if (this.selectedToMerge === artistId) {
        return
      }
      if (this.selectedToBeMerged.includes(artistId)) {
        this.selectedToBeMerged = this.selectedToBeMerged.filter(artist => artist !== artistId)
      } else {
        this.selectedToBeMerged.push(artistId)
      }
    },
    handleInput () {
      clearTimeout(this.typingTimeout)

      this.typingTimeout = setTimeout(() => {
        this.fetchKunstner()
      }, 1000)
    },
    fetchKunstner: function () {
      if (!this.artistSearch) {
        this.artistsList = []
        return
      }
      this.isLoading = true
      let searchData = {
        query: this.artistSearch
      }
      SearchService.kunstner(searchData, 1, 500)
        .then((response) => {
          this.artistsList = response.data
        })
        .catch(() => {
          console.log('Error')
        })
        .then(() => {
          this.isLoading = false
          this.selectedToMerge = ''
          this.selectedToBeMerged = []
        })
    },
    handleSubmit () {
      if (!this.selectedToMerge || !this.selectedToBeMerged.length) {
        return
      }
      this.showMergeModal = true
    },
    confirmMerge () {
      this.isLoading = true
      const data = {
        toMerge: this.selectedToMerge,
        toBeMerged: this.selectedToBeMerged.join(',')
      }

      KunstnerService.merge(data)
        .then(() => {
          this.$helpers.showSuccessAlert('Artists merged')
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Failed to merge artists', '', 'danger')
        })
        .then(() => {
          this.typingTimeout = setTimeout(() => {
            this.selectedToMerge = ''
            this.selectedToBeMerged = []
            this.artistsList = []
            this.fetchKunstner()
            this.showMergeModal = false
          }, 1000)
        })
    },
    getArtistName (id) {
      const artist = this.artistsList.find(a => a.Idnr === id)
      return artist ? artist.Navn : id
    },
    handleDelete (artistId) {
      this.selectArtistsToBeMerged(artistId)
      var vm = this

      this.openConfirm(
        'Are you sure you want to delete this Artist?',
        'This action cannot be reverted',
        'Delete',
        'Cancel',
        function () {
          vm.isLoading = true
          KunstnerService.delete(artistId)
            .then(() => {
              vm.$helpers.showSuccessAlert('Artist deleted')
            })
            .catch(() => {
              vm.$helpers.showErrorAlert('Failed to delete the artist', '', 'danger')
            })
            .then(() => {
              setTimeout(() => {
                vm.selectedToMerge = ''
                vm.selectedToBeMerged = []
                vm.artistsList = []
                vm.fetchKunstner()
                vm.closeModal()
              }, 1000)
            })
        },
        function () {
          vm.closeModal()
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Verktoy/VerktoyKunstnerMerge.vue